import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

export const OverlayContainer = styled(motion.div)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,
  padding: '20px 20px',
  background: 'linear-gradient(180deg, #ffffff 0%, #f8f9ff 100%)',
  textAlign: 'center',
  overflow: 'auto',
});

export const ContentWrapper = styled(Box)({
  maxWidth: '340px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const IconContainer = styled(Box)<{ variant: 'expired' | 'success' }>(({ variant }) => ({
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 24px',
  background: variant === 'success'
    ? 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)'
    : 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
  boxShadow: variant === 'success'
    ? '0 8px 24px rgba(76, 175, 80, 0.3)'
    : '0 8px 24px rgba(244, 67, 54, 0.2)',
}));

export const ContactSalesLink = styled('a')({
  display: 'inline-block',
  marginTop: '24px',
  padding: '14px 36px',
  fontSize: '1rem',
  fontWeight: 600,
  borderRadius: '12px',
  textTransform: 'none',
  textDecoration: 'none',
  background: 'transparent',
  color: '#1a237e',
  border: '2px solid #1a237e',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  '&:hover': {
    background: 'rgba(26, 35, 126, 0.08)',
    borderColor: '#3949ab',
  },
});

export const MinimizeButton = styled(IconButton)({
  position: 'absolute',
  top: '8px',
  right: '8px',
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  color: '#616161',
  padding: '8px',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    color: '#1a237e',
  },
});
